import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { cookies } from '@buzzfeed/bf-utils';
import styles from './search.module.scss.js';

/* eslint-disable camelcase */
const maxSuggestionsToDisplay = 5;
const cookieName = 'shopping-suggested';
const suggestions = ['Subscription boxes', 'Black-owned', 'Swimsuit', 'SPF', 'Blender', 'Splurge-worthy', 'Queer-owned', 'Dyson', 'Etsy', 'Bike shorts', 'Nordstrom', 'Woman-owned', 'Memory foam mattress', 'Exercise bike', 'Asian-owned', 'Cleaning products', 'Eco-friendly', 'Retinol', 'Dog toy'];
function getRandomSuggestions() {
  const randomSuggestions = [];
  while (randomSuggestions.length < maxSuggestionsToDisplay && suggestions.length) {
    const index = Math.floor(Math.random() * suggestions.length);
    randomSuggestions.push(suggestions[index]);
    suggestions.splice(index, 1);
  }
  return randomSuggestions;
}
function Suggestion(_ref) {
  let {
    suggestion,
    tracking,
    useUnitTracking
  } = _ref;
  const href = `/shopping/search?q=${suggestion}`;
  const trackingLayer = useMemo(() => ({
    ...tracking,
    item_type: 'text',
    target_content_type: 'url',
    item_name: suggestion,
    target_content_url: href
  }), [tracking, suggestion, href]);
  const trackingRef = useUnitTracking(trackingLayer);
  return /*#__PURE__*/React.createElement("li", {
    className: styles.suggestion
  }, /*#__PURE__*/React.createElement("a", {
    ref: trackingRef,
    href: href
  }, suggestion));
}
function SuggestedSearch(_ref2) {
  let {
    tracking,
    useUnitTracking
  } = _ref2;
  const [suggested, setSuggested] = useState(null);
  useEffect(() => {
    // only set stored suggestions once
    if (suggested) {
      return;
    }
    // try to retrieve suggestions from cookies
    let inCookies = cookies.get(cookieName);
    if (inCookies) {
      setSuggested(inCookies.split(','));
      return;
    }
    // generate random suggestions
    const randomSuggestions = getRandomSuggestions();
    setSuggested(randomSuggestions);
    // save suggestions to cookies for a day
    cookies.set({
      name: cookieName,
      value: randomSuggestions.join(','),
      days: 1,
      domain: window.location.hostname
    });
  }, [suggested]);
  if (!suggested) {
    return '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.suggestionSection
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles.searchLabel
  }, "Suggested searches"), /*#__PURE__*/React.createElement("ul", null, suggested.map((suggestion, index) => /*#__PURE__*/React.createElement(Suggestion, {
    key: `ss-${index}`,
    suggestion: suggestion,
    tracking: tracking,
    useUnitTracking: useUnitTracking
  }))));
}
SuggestedSearch.propTypes = {
  query: PropTypes.string,
  searchUrlBase: PropTypes.string,
  tracking: PropTypes.object
};

export { SuggestedSearch, SuggestedSearch as default };
